<template>
<main class="details card" v-if="chartData">

  <header>
    <span>
      <h1>{{chartData.range.human}}</h1>
    </span>
    <div class="entries-info" v-if="chartData">
      <div class="accepted"><message-square-icon/>{{chartData.dataset.acceptedCount || 0}}</div>
      <div class="rejected">
        <alert-triangle-icon/>{{chartData.dataset.rejectedCount || 0}}
      </div>
    </div>
  </header>

  <section>
    <canvas id="lineChart" v-if="!emptyChart"></canvas>
    <div v-else class="emptyChart">No entries within {{chartData.range.human}}.</div>
  </section>

</main>
</template>

<script>
import FormsService from '@/services/Forms';
// Tree shaking for chart.js not working?
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  LinearScale,
  TimeSeriesScale,
  Legend,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-dayjs';

import {
  MessageSquareIcon,
  AlertTriangleIcon,
} from 'vue-feather-icons';

export default {
  props: ['formId'],
  watch: {
    formId() {
      if (this.lineChart) this.lineChart.destroy();
      this.refreshGraph();
    },
  },
  data() {
    return {
      chartData: null,
      lineChart: null,
      emptyChart: true,
    };
  },
  created() {
    Chart.register(
      LineElement,
      PointElement,
      LineController,
      LinearScale,
      TimeSeriesScale,
      Legend,
      Tooltip,
    );
    Chart.defaults.font.size = 16;
    this.refreshGraph();
  },
  methods: {
    async refreshGraph() {
      this.emptyChart = true;
      const chartdata = await FormsService.formStats(this.formId || null);
      this.chartData = chartdata.data;
      if (this.chartData.dataset.acceptedCount > 0 || this.chartData.dataset.rejectedCount > 0) {
        this.emptyChart = false;
        setTimeout(() => { // Waiting for v-if to kick in for emptyChart
          const ctx = document.getElementById('lineChart');
          if (this.lineChart) this.lineChart.destroy();
          // eslint-disable-next-line no-unused-vars
          this.lineChart = new Chart(
            ctx,
            {
              type: 'line',
              data: {
                datasets: [
                  {
                    label: 'Accepted',
                    borderColor: '#06d6a0',
                    lineTension: 0.1,
                    data: this.chartData.dataset.accepted,
                  },
                  {
                    label: 'Rejected',
                    borderColor: '#ef476f',
                    lineTension: 0.1,
                    data: this.chartData.dataset.rejected,
                  },
                ],
              },
              options: {
                scales: {
                  x: {
                    type: 'timeseries',
                    min: new Date(this.chartData.range.start),
                    max: new Date(this.chartData.range.end),
                    time: {
                      tooltipFormat: this.chartData.range.display,
                      unit: this.chartData.range.unit,
                    },
                    grid: { display: false },
                  },
                  y: { ticks: { stepSize: 1 } },
                },
                elements: {
                  point: {
                    borderWidth: 2,
                    hitRadius: 15,
                  },
                },
                plugins: {
                  tooltip: { displayColors: false },
                },
                maintainAspectRatio: false,
              },
            },
          );
        }, 50);
      }
    },
  },
  components: {
    // LineChart,
    MessageSquareIcon,
    AlertTriangleIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  main {
    padding: 30px;
  }

  header {
    display: flex;
    align-items: center;
    padding-bottom: 2em;
    border-bottom: 1px solid #444;

  }

  header h1 {
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 2.3em;
  }

  header .entries-info {
    font-size: 2em;
    position: relative;
    text-align: center;
    margin-left: auto;
    padding-right: 30px;
    padding-bottom: 20px;
    display: flex;
  }

  header .entries-info div {
    padding-left: 15px;
    position: relative;
  }

  header .entries-info div svg {
    margin-right: 5px;
  }

  header .entries-info div:not(:last-of-type){
    margin-right: 35px;
  }

  header .entries-info div:before {
    position: absolute;
    font-size: 0.5em;
    bottom: -15px;
    right: 0;
  }

  header .entries-info .accepted:before { content: 'ACCEPTED'; }
  header .entries-info .rejected:before { content: 'REJECTED'; }

  #lineChart {
    padding: 2em;
    min-height: 400px;
  }

  .details .emptyChart { text-transform: lowercase; padding-top: 2rem; }
  .details .emptyChart::first-letter { text-transform: capitalize; }

</style>
